export default __webpack_public_path__ + "static/media/section1-item-1.d047cb96.png";